module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1302.4e7334ee.png";